<template>
  <div>
    <v-data-table
        dense
        :headers="columns"
        :items="providerCheckList"
        item-key="id"
        class="elevation-1 my-6 mx-0"
        :sort-by="['is']"
        hide-default-footer
        :loading="brandProviderCheckListLoader"
    >
      <template v-slot:item.are_comparable="{ item }">
        <BaseBoolIndicator v-bind:value=item.are_comparable></BaseBoolIndicator>
      </template>
      <template v-slot:item.last_check="{ item }">
        {{ item.last_check | moment("YY.MM.DD HH:mm") }}
      </template>
      <template v-slot:item.mpn="{ item }">
        <v-text-field
            class="mt-3 mb-n3 mpn-part-number"
            v-model="item.mpn"
            dense
            outlined
            @change="saveBrandProviderCheckList"
        ></v-text-field>
      </template>
      <template v-slot:item.part_number="{ item }">
        <v-text-field
            class="mt-3 mb-n3 mpn-part-number"
            v-model="item.part_number"
            dense
            outlined
            @change="saveBrandProviderCheckList"
        ></v-text-field>
      </template>
      <template v-slot:item.desired_qty="{ item }">
        <v-text-field
            class="mt-3 mb-n3"
            v-model="item.desired_qty"
            dense
            outlined
            @change="saveBrandProviderCheckList"
        ></v-text-field>
      </template>
      <template v-slot:item.price="{ item }">
        <v-text-field
            class="mt-3 mb-n3"
            dense
            outlined
            v-model="item.price"
            :label="(item.received_price != null) ? item.received_price.toString(): ''"
            :background-color="item.comparable_list[0] ? 'green accent-1': 'red accent-1'"
            @change="saveBrandProviderCheckList"
        >
        </v-text-field>
      </template>
      <template v-slot:item.moq="{ item }">
        <v-text-field
            class="mt-3 mb-n3"
            dense
            outlined
            v-model="item.moq"
            :label="(item.received_moq != null) ? item.received_moq.toString(): ''"
            :background-color="item.comparable_list[1] ? 'green accent-1': 'red accent-1'"
            @change="saveBrandProviderCheckList"
        >
        </v-text-field>
      </template>
      <template v-slot:item.multiple="{ item }">
        <v-text-field
            class="mt-3 mb-n3"
            dense
            outlined
            v-model="item.multiple"
            :label="(item.received_multiple != null) ? item.received_multiple.toString(): ''"
            :background-color="item.comparable_list[2] ? 'green accent-1': 'red accent-1'"
            @change="saveBrandProviderCheckList"
        >
        </v-text-field>
      </template>
      <template v-slot:item.stock="{ item }">
        <v-text-field
            class="mt-3 mb-n3"
            dense
            outlined
            v-model="item.stock"
            :label="(item.received_stock != null) ? item.received_stock.toString(): ''"
            :background-color="item.comparable_list[3] ? 'green accent-1': 'red accent-1'"
            @change="saveBrandProviderCheckList"
        >
        </v-text-field>
      </template>
      <template v-slot:item.actions="{ item }">
<!--        <v-btn class="mx-2" fab dark x-small color="error" @click="deleteBrandProviderCheckList(item)"-->
<!--               :loading="deleteLoading">-->
<!--          <v-icon>mdi-minus</v-icon>-->
<!--        </v-btn>-->
        <v-icon color="error" @click="deleteBrandProviderCheckList(item)" :loading="deleteLoading">mdi-delete</v-icon>
      </template>
      <template v-slot:top>
        <v-toolbar color="grey lighten-2" flat dense>
          <v-toolbar-title>Checkings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-2" fab dark x-small color="primary" @click="addBrandProviderCheckList"
                   :loading="addLoading">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'BrandProviderCheckList',
  props: ['brandProviderId'],

  components: {},

  computed: mapGetters(['getProviderCheckList', 'getBrandProviderCheckListLoader']),

  methods: {
    async fetchBrandProviderCheckList() {
      this.brandProviderCheckListLoader = true
      const requestParams = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'credentials': "same-origin",
        },
      };
      const res = await fetch("/api/provider_check/?provider_id=" + this.brandProviderId, requestParams);
      if (!res.ok) {
        const result = await res.json()
        this.$root.$store._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
        return
      }
      this.providerCheckList = await res.json();
      this.brandProviderCheckListLoader = false
      // console.log("providerCheckList")
      // console.log(this.providerCheckList)
    },
    async saveBrandProviderCheckList() {
      console.log('saveBrandProviderCheckList')
      this.brandProviderCheckListLoader = true
      let csrfToken = this.$root.$store._vm.$readCookie('csrftoken')
      for (let providerCheck of this.providerCheckList) {
        const requestParams = {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            'credentials': "same-origin",
            'X-CSRFToken': csrfToken,
          },
          body: JSON.stringify({
            'mpn': providerCheck.mpn,
            'part_number': providerCheck.part_number,
            'desired_qty': providerCheck.desired_qty,
            'price': providerCheck.price,
            'moq': providerCheck.moq,
            'multiple': providerCheck.multiple,
            'stock': providerCheck.stock,
          })
        };
        const res = await fetch("/api/provider_check/" + providerCheck.id + "/", requestParams);
        if (!res.ok) {
          const result = await res.json()
          this.$root.$store._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
        }
      }
      this.brandProviderCheckListLoader = false
    },
    async addBrandProviderCheckList() {
      console.log('addBrandProviderCheckList')
      console.log(this.brandProviderId)
      this.addLoading = true
      let csrfToken = this.$root.$store._vm.$readCookie('csrftoken')
      const requestParams = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'credentials': "same-origin",
          'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify({
          'provider': parseInt(this.brandProviderId),
        })
      };
      const res = await fetch("/api/provider_check/", requestParams);
      if (!res.ok) {
        const result = await res.json()
        this.$root.$store._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
        this.addLoading = false
        return
      }
      const result = await res.json()
      this.providerCheckList.push(result)
      this.addLoading = false
    },
    async deleteBrandProviderCheckList(item) {
      console.log('deleteBrandProviderCheckList')
      console.log(item)
      this.deleteLoading = true
      let csrfToken = this.$root.$store._vm.$readCookie('csrftoken')
      const requestParams = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          'credentials': "same-origin",
          'X-CSRFToken': csrfToken,
        },
        body: JSON.stringify({
          'provider': parseInt(this.brandProviderId),
        })
      };
      const res = await fetch("/api/provider_check/" + item.id + '/', requestParams);
      if (!res.ok) {
        const result = await res.json()
        this.$root.$store._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
        this.deleteLoading = false
        return
      }
      this.providerCheckList = this.providerCheckList.filter(component => component.id != item.id)
      this.deleteLoading = false
    }
  },

  async mounted() {
    console.log('Mounted')
    await this.fetchBrandProviderCheckList();
  },

  data() {
    return {
      providerCheckList: [],
      brandProviderCheckListLoader: false,
      // saveLoading: false,
      addLoading: false,
      deleteLoading: false,
      columns: [
        {text: '', value: 'are_comparable', sortable: false, divider: true},
        {text: 'Last check', value: 'last_check', sortable: false, divider: true},
        {text: 'MPN', value: 'mpn', sortable: false, filterable: false, divider: true},
        {text: 'P/N', value: 'part_number', sortable: false, filterable: false, divider: true},
        {text: 'Desired QTY', value: 'desired_qty', sortable: true, filterable: true, width: "100px", divider: true},
        {text: 'Price', value: 'price', sortable: true, filterable: true, width: "120px", divider: true},
        {text: 'MOQ', value: 'moq', sortable: false, width: "100px", divider: true},
        {text: 'Multiple', value: 'multiple', sortable: false, width: "100px", divider: true},
        {text: 'Stock', value: 'stock', sortable: false, width: "100px", divider: true},
        {text: 'Actions', value: 'actions', sortable: false, divider: true},
      ],
    }
  }
}
</script>

<style scoped lang="scss">
.mpn-part-number {
  width: 200px;
}
</style>
